import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { data } from 'jquery';
import config from '../../../assets/config.json';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import * as XLSX from 'xlsx';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

const formControls: any = {};
@Component({
  selector: 'app-create-work-item',
  templateUrl: './create-work-item.component.html',
  styleUrls: ['./create-work-item.component.css'],
})
export class CreateWorkItemComponent implements OnInit {
  attachmentName: string = "";
  attachmentFile: File | null = null;
  dateFormat = new DatePipe('en-US');
  docTypeList: any = [];
  subdocTypeList: any = [];
  selectedDocumentType: any = { docTypeId: 0, docTypeName: '', isCommentMandatory: false };
  selectedSubDocumentType: any = { subdocTypeId: 0, subdocTypeName: '' };
  isOpenDoctypeModel: boolean = true;
  workItemFieldList: any = [];
  frmInvoice: FormGroup;
  submitted: boolean = false;
  base64FileString: string = '';
  fileControlType = 'file'; //for SSA fixing (we have checked upload file type)
  subdocselected = "0";
  //lstDuplicateData: { Column: string, 'Comp Type': string, 'Operator': string, 'Value': string, 'Connector': string }[] = []; 
  lstDuplicateData: any = [];
  //nextQueueselected : any = { process_id: 0, process_name: '', isProcessQueueMandatory: false };
  lstprocessQueue: any = [];
  is_Addprocess_In_Create_Work_page: boolean = false;
  // word count var start
  wordsTotal: any = 1000;
  strComments: string = '';
  // word count ver end
  @ViewChild('invFileUpload') fileInput: ElementRef;

  invoiceComment = 'invoiceComment';
  uploadFileName = 'uploadFileName';
  restrictedKeywords: any = [];
  invoiceattachmentList = [];
  //@ViewChild('fileUpload') supportfileInput: ElementRef;
  @ViewChild('fileUpload') supportfileInput!: ElementRef<HTMLInputElement>;

  fileBase64FileString: string = '';
  attachmentList = [];
  isCommentExpand: boolean = false;
  isShowUploadedDocs: boolean = false;
  isBright: boolean = true;
  createdInvoiceURN: string = '';
  potentialDuplicate: string = '';
  isDuplicate: boolean = false;
  duplicateDataKeys: any = [];
  isCategorySelected: boolean = false;
  changeDuplicateColumnsToHide: any = ['DOCUMENT_DETAIL_ID', 'REF_DOCUMENT_DETAIL_ID', 'CLIENT_CONDITION', 'DB_COLUMN_NAMES', 'FIELD_NAME']
  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;
  @ViewChild('documentTypeModal') documentTypeModal: ElementRef;
  @ViewChild('duplicateInvoiceSubmittedModal') duplicateInvoiceSubmittedModal: ElementRef;

  db_columns_values_list = {};//prakash
  dependant_dropdown_list = [];// prakash
  modalReference: any;
  documentType_MST: any;
  is_OCR_Enabled: boolean = false;
  company_type: string = "TML";
  lstSection = [];
  invoiceDocValidFileExtensions = [];
  supportDocValidFileExtensions = [];
  invoiceDocFileSize = {};
  supportDocFileSize = {};
  // _validFileExtensions = this.commonService.validFileExtensions.replace(',', '/');
  // _fileSize = this.commonService.fileSize;

  //Added for bulk FileUpload 
  isLoadProgress: boolean = false;
  file: File;
  fileSize: any;
  fileSizeInWords: any;
  fileInvName: any = "";
  invcontrolName: any = "";
  invoicebase64FileString: string = '';
  showUploadcontroll: boolean = true;
  // uploadFlag: any[] = [1, 2, 3, 4, 5,26];
  projectIdForUploadFlag: number;
  //end
  UploadedJsonData: any = [];//added by Dharshana for PII data check
  PiiCheckModel: boolean = false;
  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private renderer: Renderer2,
    private encryptDecryptservice:EncryptDecryptService,
    private memorystore: MemoryStorageService
    // private dailogbox:ConfirmationDialogComponent
  ) {
    //wowService.init();

  }

  ngOnInit(): void {
    //added by venkat for Enabling/disabling upload functionality based on Project -03062024
    this.projectIdForUploadFlag = this.commonService.selectedProject;
    var selected_id = config.not_require_upload_project.filter(x => x == this.projectIdForUploadFlag);
    if (selected_id != undefined && selected_id != null && selected_id.length != 0) {
      this.showUploadcontroll = false;
    } else {
      this.showUploadcontroll = true;
    }
    //ends here


    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
    this.getDocumentTypes();
    this.isDuplicate = false;
    if (config.is_Addprocess_In_Create_Work_page == false || config.is_Addprocess_In_Create_Work_page == undefined) {
      this.is_Addprocess_In_Create_Work_page = false;
    }
    else {
      this.is_Addprocess_In_Create_Work_page = true;
      this.getprocessQueue();
    }

  }

  function(data) {
    this.wordsTotal = this.wordsTotal - data.length
  }
  getprocessQueue() {
    this.lstprocessQueue = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    this.dataService.getData('nextqueue', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.lstprocessQueue.push({
              process_id: res.data[i].process_id,
              process_name: res.data[i].process_name,
              isProcessQueueMandatory: true
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    }
    );
  }

  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id',this.encryptDecryptservice.encryptUsingAES256( this.commonService.selectedSubgroup));
    params = params.append('action', 'manual creation');
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService
      .getData('document-types', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.documentType_MST = res.data;
              for (var i = 0; i < res.data.length; i++) {
                this.docTypeList.push({
                  docTypeId: res.data[i].document_type_id,
                  docTypeName: res.data[i].document_type_name,
                  isCommentMandatory: res.data[i].is_comment_mandatory_for_create_workitem
                });
              }
              this.showModal(this.documentTypeModal, 'sm');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }
  //added by gobi
  async getSubDocumentTypes() {
    this.subdocTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('document_type_id', this.selectedDocumentType.docTypeId);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('document_type_id', this.encryptDecryptservice.encryptUsingAES256(this.selectedDocumentType.docTypeId));
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    await this.dataService
      .getDataPromise('dropdown_subdocumenttype', params)
      .then(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              for (var i = 0; i < res.data.length; i++) {
                this.subdocTypeList.push({
                  subdocTypeId: res.data[i].sub_document_type_id,
                  subdocTypeName: res.data[i].sub_doctype_name,
                });
              }

            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );

    if (this.subdocTypeList != null && this.subdocTypeList.length > 0) {
      this.isCategorySelected = false;
    }
    else {
      this.selectedSubDocumentType.subdocTypeId = 0;
      this.isCategorySelected = true;
      this.getWorkItemFields();
    }
  }
  changeSubDocumentValue(event: MatSelectChange) {
    this.selectedSubDocumentType = {
      subdocTypeId: event.value,
      subdocTypeName: event.source.triggerValue
    };
    if (event.value == 0) {
      this.isCategorySelected = false;
    }
    else {
      this.isCategorySelected = true;
    }

    //this.commonService.setUserInfoToLocalStorage('subdocId', this.selectedSubDocumentType.subdocTypeId);
    this.getWorkItemFields();
  }
  //end

  async onChangeDoctype(docType: any) {
    this.isOpenDoctypeModel = false;
    this.selectedDocumentType = docType;
    this.selectedSubDocumentType.subdocTypeId = 0;
    this.isCategorySelected = false;
    this.subdocselected = "0";
    this.subdocTypeList = [];

    //this.changeSubDocumentValue(0);
    await this.getSubDocumentTypes();
    this.getInvoiceDocuments();
    this.getSupportingDocuments();
    //this.commonService.setUserInfoToLocalStorage('subdocId', this.selectedSubDocumentType.subdocTypeId);
    this.getprocessQueue();
    this.modalReference.close();
  }

  getWorkItemFields() {
    this.workItemFieldList = [];
    let params = {
      // project_id: this.commonService.selectedProject,
      // document_type_id: this.selectedDocumentType.docTypeId,
      // subgroup_id: this.commonService.selectedSubgroup,
      // sub_document_type_id: this.selectedSubDocumentType.subdocTypeId
      project_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      document_type_id: this.encryptDecryptservice.encryptUsingAES256(this.selectedDocumentType.docTypeId),
      // subgroup_id: this.commonService.selectedSubgroup,
      // sub_document_type_id: this.selectedSubDocumentType.subdocTypeId
    };
    this.dataService.getData('dynamic_fields_subdocType', params).subscribe((res) => {
      //this.dataService.getData('dynamic_fields', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) this.workItemFieldList = res.data;
        else this.workItemFieldList = [];

        if (res != null && res.data != null) this.workItemFieldList = res.data;
        else this.workItemFieldList = [];

        this.lstSection = [];
        this.workItemFieldList.forEach(item => {

          if (this.lstSection.findIndex(s => s.SECTION_NAME == item.section_name) == -1) {
            let lst = this.workItemFieldList.filter(x => x.section_name == item.section_name);
            this.lstSection.push({ SECTION_ID: item.section_name, SECTION_NAME: item.section_name, FIELDS_DETAIL: lst, SECTION_ORDER: item.section_order });
          }
        });
        const formControls: any = {};
        this.workItemFieldList.forEach(async (field) => {

          let fieldValidators = [];
          if (
            field.control_type == 'FILE' ||
            field.is_mandatory == 1
          ) {
            fieldValidators = [Validators.required];
          }

          // Hard coded logic for TML(TATA Motors Ltd) for Company Type field
          let defaultValue =
            field.control_type == 'DATE' ? null : field.control_type == 'DROPDOWN' ? field.dropdown_type == 'PredefinedMst' &&
              field.dropdown_value != null ? +field.dropdown_value.trim() : null : field.control_type == 'CHECKBOX' ? false : '';
          this.db_columns_values_list[field.db_column_name] = defaultValue;
          formControls[field.db_column_name] = new FormControl({ value: defaultValue, disabled: field.is_readonly == 1 }, fieldValidators);

          if (field.control_type == 'TEXTBOX') {
            field.value_type = field.validation_type == 'NUMERIC' ? 'number' : 'text';
          }
          if (field.actions != null) {
            field.actions = JSON.parse(field.actions);
          }
          if (field.control_type == 'DROPDOWN') {
            //By Prakash
            //field.options = JSON.parse(field.options);
            let magnify_dependant_fields = {};
            let dropdown_dependant_parameter = {};
            if (field.magnify_dependant_fields != null && field.magnify_dependant_fields != undefined) {
              magnify_dependant_fields = JSON.parse(field.magnify_dependant_fields);
              Object.keys(magnify_dependant_fields).forEach(x => {

                let field_value = this.db_columns_values_list[magnify_dependant_fields[x]];
                if (field_value != null && field_value != '' && field_value != undefined) {
                  dropdown_dependant_parameter[x] = field_value.toString();
                }
              });
            }
            field.dropdown_dependant_parameter = dropdown_dependant_parameter;

            if (field.is_autocomplete == 0 && field.is_readonly == 0) {
              field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
              //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
            }
            else if (field.is_autocomplete == 0 && field.is_readonly == 1) {
              if (defaultValue != null && defaultValue != undefined)
                field.field_value = defaultValue;
              if (field.field_value == "" || field.field_value == undefined)
                field.field_value = 0;

              field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
            }
            else {
              if (field.field_value == "" || field.field_value == undefined)
                field.field_value = "";

              field.options = await this.commonService.getAutocomplete_dropdowndata(field.field_mapping_detail_id, field.field_value, 'id')
              //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
            }
            //Gabriel start
            //dependant field event called for page load if fields readonly
            if (field.is_dependant == 1 && field.field_value != null) {
              // this.getDependantFields(field.field_mapping_detail_id, fieldVal);                    
              this.getDependantFields(
                field.field_mapping_detail_id, field.field_value
              );
              //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
              //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
            }
            //Gabriel end

            //field.options = [...new Map(field.options.map(item => [item['name'], item])).values()];
            // field.options.splice(0, 0, { id: 0, name: '-- Select --' });
          }

          if (this.selectedDocumentType.docTypeName == "Change Request") {
            if (field.field_name == 'Raised date') {
              var currentDateValue = new Date();
              formControls[field.db_column_name] = new FormControl({ value: currentDateValue, disabled: 1 }, fieldValidators);
            }
            else if (field.field_name == 'Raised By') {
              // defaultValue = this.commonService.getUserInfoFromLocalStorage('userName');
              defaultValue = this.memorystore.getItem('userName');
              formControls[field.db_column_name] = new FormControl({ value: defaultValue, disabled: 1 }, fieldValidators);
            }
            // else if(field.field_name=='Expected Closure Date')
            // {
            //   var currentDateValue = new Date();
            //  formControls[field.db_column_name] = new FormControl({ value: currentDateValue, disabled: field.is_readonly == 1 }, fieldValidators);

            // }

          }
          // if (this.commonService.getUserInfoFromLocalStorage('projectName') == "Import Payment Voucher") {
            if (this.memorystore.getItem('projectName') == "Import Payment Voucher") {  
          //this.commonService.getUserInfoFromLocalStorage('projectName');
            if (field.field_name == 'Creation Date') {
              var currentDateValue = new Date();
              formControls[field.db_column_name] = new FormControl({ value: currentDateValue, disabled: 1 }, fieldValidators);
            }
            else if (field.field_name == 'Created by Name') {
              // defaultValue = this.commonService.getUserInfoFromLocalStorage('userName');
              defaultValue = this.memorystore.getItem('userName');
              formControls[field.db_column_name] = new FormControl({ value: defaultValue, disabled: 1 }, fieldValidators);
            }
            else if (field.field_name == 'Created by Designation') {
              //this.commonService.getUserInfoFromLocalStorage('roleName')
              // defaultValue = this.commonService.getUserInfoFromLocalStorage('roleName');
              defaultValue = this.memorystore.getItem('roleName');
              formControls[field.db_column_name] = new FormControl({ value: defaultValue, disabled: 1 }, fieldValidators);
            }
            else if (field.field_name == 'Created by Dept') {
              // defaultValue = this.commonService.getUserInfoFromLocalStorage('projectName');
              defaultValue = this.memorystore.getItem('projectName');
              formControls[field.db_column_name] = new FormControl({ value: defaultValue, disabled: 1 }, fieldValidators);
            }
          }

        });
        if (this.selectedDocumentType.isCommentMandatory == true)
          formControls[this.invoiceComment] = new FormControl('', [Validators.required,]);
        else
          formControls[this.invoiceComment] = new FormControl('');

        formControls[this.uploadFileName] = new FormControl('', []);

        formControls['nextQueueselected'] = new FormControl('', []);

        this.frmInvoice = new FormGroup(formControls);
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    }
    );
  }

  openAdvanceSearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null, predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field_value = this.frmInvoice.get(magnifyDependantFields[x]).value;
        if (field_value != null && field_value != '' && field_value != undefined) {
          // let field = this.workItemFieldList.find(f => f.db_column_name == magnifyDependantFields[x]);
          // if (field != undefined && field.control_type == 'DROPDOWN') {
          //   field_value = field.options.find(d => d.id == field_value).name;
          // }
          dependantFieldValues[x] = field_value.toString();
        }
      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {

      const selectedField = this.workItemFieldList.find(
        (x) => x.field_mapping_detail_id == res.fieldId
      );

      if (selectedField.control_type == 'DROPDOWN') {
        const selectedOptionField = selectedField.options.find(
          (x) => x.id == res.fieldValue
        );
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(selectedOptionField['id']);
        this.changeDropdownFieldValue(selectedField);
      } else if (selectedField.control_type == 'TEXTBOX') {
        this.frmInvoice
          .get(selectedField.db_column_name)
          .setValue(res.fieldValue.toString());
        this.changeTextFieldValue(selectedField);
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  // uploadFileEvt(imgFile: any, controlId: string) {
  //   this.invcontrolName=controlId;
  //   this.frmInvoice.controls[controlId].setValue('Choose File');
  //   if (this.commonService.validateFileUpload(imgFile.target.files[0], this.invoiceDocValidFileExtensions, this.invoiceDocFileSize)) {
  //     if (imgFile.target.files && imgFile.target.files[0]) {

  //       let fileName = imgFile.target.files[0].name.split('.').slice(0, -1).join('');
  //       let fileExt = imgFile.target.files[0].name.split('.').pop();

  //       this.frmInvoice.controls[controlId].setValue(
  //         fileName + '.' + fileExt
  //       );

  //       this.file=imgFile.target.files[0];
  //       this.fileInvName=imgFile.target.files[0].name;
  //       let reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         this.base64FileString = reader.result.toString();
  //         this.uploadInvAttachment(e);
  //       };
  //       reader.readAsDataURL(imgFile.target.files[0]);

  //       this.fileInput.nativeElement.value = '';
  //     } else {
  //       this.frmInvoice.controls[controlId].setValue('Choose File');
  //     }
  //   }
  //   else {
  //     this.frmInvoice.controls[controlId].setValue('');
  //     this.base64FileString = '';
  //   }
  // }

  uploadFileEvt(imgFile: any, controlId: string) {
    debugger;
    this.invcontrolName = controlId;
    this.frmInvoice.controls[controlId].setValue('Choose File');
    if (this.commonService.validateFileUpload(imgFile.target.files[0], this.invoiceDocValidFileExtensions, this.invoiceDocFileSize)) {
      if (imgFile.target.files && imgFile.target.files[0]) {

        let fileName = imgFile.target.files[0].name.split('.').slice(0, -1).join('');
        let fileExt = imgFile.target.files[0].name.split('.').pop();

        this.frmInvoice.controls[controlId].setValue(
          fileName + '.' + fileExt
        );
        this.file = imgFile.target.files[0];
        this.fileInvName = imgFile.target.files[0].name;
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.invoicebase64FileString = reader.result.toString();
          this.uploadInvAttachment(e);
        };
        reader.readAsDataURL(imgFile.target.files[0]);

        this.fileInput.nativeElement.value = '';
      } else {
        this.frmInvoice.controls[controlId].setValue('Choose File');
      }
    }
    else {
      this.frmInvoice.controls[controlId].setValue('');
      this.invoicebase64FileString = '';
    }
  }


  changeTextFieldValue(field: any) {
    let fix_length = 0;
    if (field.min_length == field.max_length) {
      fix_length = field.min_length;
    }

    let field_value = this.frmInvoice.get(field.db_column_name).value;

    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        field_value
      );
    }
    if (field.actions != null) {
      // execute actions/query if any
      field.actions.forEach(action => {
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
          let formula = action.formula;

          action.formula_fields.split(",").forEach(f => {
            let field_value = this.frmInvoice.get(f).value;
            formula = formula.replace(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
          });
          let formulaValue = eval(formula);

          this.frmInvoice.get(action.target_db_column_name)
            .setValue(formulaValue);
        }
      });
    }

    if (field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') {
      field_value = this.commonService.handleNumberInput(field, field_value);
      if (field_value.length <= fix_length) {
        this.frmInvoice.get(field.db_column_name).setValue(field_value);

      }
      // this.frmInvoice.get(field.db_column_name).setValue(field_value);

    }

  }

  changeDropdownFieldValue(field: any) {
    if (field.is_dependant == 1) {
      this.getDependantFields(
        field.field_mapping_detail_id,
        this.frmInvoice.get(field.db_column_name).value
      );
    }
  }

  getDependantFields(fieldMappingDetailId: number, selectedValue: any) {
    let params = {
      field_mapping_detail_id: fieldMappingDetailId,
      selected_value: selectedValue,
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };

    this.dataService.getData('dependant', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res != undefined) {
          if (res.data.length > 0) {
            res.data.forEach((ele) => {
              ele.values = JSON.parse(ele.values);
              if (ele.control_type == 'DROPDOWN') {
                const uniqueData = [...new Map(ele.values.map(item => [item['name'], item])).values()];
                this.workItemFieldList.find(
                  (x) => x.db_column_name == ele.db_column_name
                ).options = uniqueData;
                if (uniqueData.length == 1) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(uniqueData[0]['id']);
                }
              } else if (ele.control_type == 'TEXTBOX') {
                if (ele.values.length > 0) {
                  this.frmInvoice
                    .get(ele.db_column_name)
                    .setValue(ele.values[0].name);
                } else {
                  this.frmInvoice.get(ele.db_column_name).setValue('');
                }
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  processAsDuplicateInvoice() {
    this.isDuplicate = true;
    this.submitInvoice();

  }

  //   submitInvoice() {
  //     this.submitted = true;
  //     let isSubmitValid = true;
  //     let invalidSubmitMsg = '';
  //     let invalidLengthMsg = '';

  //     if (this.frmInvoice.invalid) {
  //       invalidSubmitMsg += 'Please fill the required field(s)\r <br/>';
  //       isSubmitValid = false;
  //     }

  //     // if (this.frmInvoice.value['invoiceComment'].trim() == '') {
  //     //   invalidSubmitMsg += 'Comment is mandatory\r <br/>';
  //     //   isSubmitValid = false;
  //     // }

  //     if (
  //       this.workItemFieldList.findIndex((x) => x.control_type == 'FILE') != -1 &&
  //       this.base64FileString == ''
  //     ) {
  //       invalidSubmitMsg += 'Please select file\r <br/>';
  //       isSubmitValid = false;
  //     }

  //     if (this.selectedDocumentType.isCommentMandatory && (this.frmInvoice.get(this.invoiceComment).value == '' ||
  //       this.frmInvoice.get(this.invoiceComment).value == undefined ||
  //       this.frmInvoice.get(this.invoiceComment).value == null)
  //     ) {
  //       invalidSubmitMsg += 'Comment is mandatory.\r <br/>';
  //       isSubmitValid = false;
  //     }   

  //     if(config.is_Addprocess_In_Create_Work_page==true && (this.frmInvoice.get('nextQueueselected').value == 0 || this.frmInvoice.get('nextQueueselected').value == "" ||
  //     this.frmInvoice.get('nextQueueselected').value == undefined ||
  //     this.frmInvoice.get('nextQueueselected').value == null)){
  //       invalidSubmitMsg += 'Next Queue is mandatory.\r <br/>';
  //       isSubmitValid = false;
  //     }    

  //     if (!isSubmitValid) {
  //       this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
  //       return;
  //     }

  //     let fieldsData = [];
  //     let lst = [];
  //     let lstRow = this.frmInvoice.getRawValue();
  //     let formValue = "";

  //     this.workItemFieldList.forEach(field => {

  //       formValue = lstRow[field.db_column_name];
  //       let displayText = '';

  //       if (formValue != undefined && formValue != null)
  //         formValue = formValue.toString();
  //       else
  //         formValue = '';

  //       // START: field length validation
  //       if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
  //         let fix_length = 0;
  //         if (field.min_length == field.max_length) {
  //           fix_length = field.min_length;
  //         }

  //         if (fix_length > 0 && (field.is_mandatory == 1 || formValue != '')) {

  //           if (formValue.toString().length != fix_length) {
  //             if (invalidLengthMsg == "")
  //               invalidLengthMsg = "Length of " + field.field_name + " must be " + fix_length + ".";
  //             else
  //               invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " must be " + fix_length + ".";
  //           }
  //         }

  //         if (fix_length == 0 && field.min_length > 0 && (field.is_mandatory == 1 || formValue != '')) {
  //           if (formValue.toString().length < field.min_length) {
  //             if (invalidLengthMsg == "")
  //               invalidLengthMsg = "Length of " + field.field_name + " is min " + field.min_length + ".";
  //             else
  //               invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is min " + field.min_length + ".";
  //           }
  //         }

  //         if (fix_length == 0 && field.max_length > 0) {
  //           if (formValue.toString().length > field.max_length) {
  //             if (invalidLengthMsg == "")
  //               invalidLengthMsg = "Length of " + field.field_name + " is up to " + field.max_length + ".";
  //             else
  //               invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is up to " + field.max_length + ".";
  //           }
  //         }
  //       }
  //       // END: field length validation

  //       let value: string = ""

  //       if (field.control_type == "DATE") {
  //         value = this.commonService.dateFormating(formValue);
  //       }
  //       else {
  //         value = formValue;
  //       }

  //       if (field.control_type == "DROPDOWN") {
  //         displayText = field.options.find(d => d.id == value)?.name;
  //       }

  //       fieldsData.push({
  //         db_column_name: field.db_column_name,
  //         field_val: value.toString().trim(),
  //         controlType: field.control_type,
  //         displayText: displayText == undefined ? '' : displayText
  //       });

  //       lst.push({
  //         ParameterName: field.db_column_name,
  //         ParameterValue: value.toString().trim()
  //       });

  //     });

  //     if (invalidLengthMsg != '') {
  //       this.commonService.showMessageBox(invalidLengthMsg, 'Alert');
  //       return;
  //     }

  // let toProcessId: number=0;
  // let is_request_Addprocess_In_Create_Work_page: string = "FALSE"
  //     if(config.is_Addprocess_In_Create_Work_page==true && (this.frmInvoice.get('nextQueueselected').value != 0)){      

  //         if(config.is_Addprocess_Id==this.frmInvoice.get('nextQueueselected').value) 
  //         {
  //           toProcessId=this.frmInvoice.get('nextQueueselected').value;
  //           is_request_Addprocess_In_Create_Work_page = "TRUE"
  //         }

  //     }  

  //     let df_params = {
  //       document_type_id: this.selectedDocumentType.docTypeId,
  //       document_detail_id: 0,
  //       lstParameter: lst,
  //       fromProcessId: 0,
  //       toProcessId: 0
  //     };

  //     //let Duplicate_ref_id: string = '';

  //     let jsonDuplicate: string = ''
  //     if (this.isDuplicate == false) {
  //       this.lstDuplicateData = [];
  //     }

  //     this.dataService.postData('getduplicate', df_params).subscribe((res) => {

  //       if (res?.data?.Table?.length > 0 && this.isDuplicate == false) {
  //         this.lstDuplicateData = res.data.Table;
  //         this.duplicateDataKeys = Object.keys(this.lstDuplicateData[0]);
  //         this.showModal(this.duplicateInvoiceSubmittedModal, 'xl');
  //         //Duplicate_ref_id = res.data.Table[0].DUPLICATE_REF_ID

  //       }
  //       else {
  //         if (this.lstDuplicateData.length > 0) {
  //           this.potentialDuplicate = " as potential duplicate";
  //           jsonDuplicate = JSON.stringify(this.lstDuplicateData);

  //         }
  //         else {
  //           this.potentialDuplicate = "";
  //         }

  //         let params = {
  //           user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
  //           invoice_file: this.base64FileString,
  //           fields_data: fieldsData,
  //           document_type_id: this.selectedDocumentType.docTypeId,
  //           comments: this.frmInvoice.value['invoiceComment'],
  //           subgroup_id: this.commonService.selectedSubgroup,
  //           priority: this.finalValue.toUpperCase(),
  //           support_document_comments: this.frmInvoice.get(this.invoiceComment).value,
  //           duplicate_ref_id: jsonDuplicate,
  //           sub_doctype_id: this.selectedSubDocumentType.subdocTypeId,
  //           project_id: Number(this.commonService.selectedProject),
  //           process_id:toProcessId,
  //           is_Addprocess_In_Create_Work_page :is_request_Addprocess_In_Create_Work_page,
  //         };

  //         this.dataService.postData('workitem', params).subscribe((res) => {
  //           if (res.data != null && res.data.length > 0 && res.data[0].urn != '') {
  //             this.submitAttachments(res.data[0]);
  //             this.createdInvoiceURN = res.data[0].urn;
  //             this.commonService.setUserInfoToLocalStorage('documentDetailId', res.data[0].document_detail_id);
  //             this.showModal(this.invoiceSubmittedModal, 'lg');
  //           } else {
  //             this.commonService.showMessageBox(res.error_message, 'Alert');
  //           }
  //         });
  //         this.isDuplicate = false;
  //       }


  //     });

  //   }

  submitInvoice() {
    this.submitted = true;
    let isSubmitValid = true;
    let invalidSubmitMsg = '';
    let invalidLengthMsg = '';

    if (this.frmInvoice.invalid) {
      invalidSubmitMsg += 'Please fill the required field(s)\r <br/>';
      isSubmitValid = false;
    }

    // if (this.frmInvoice.value['invoiceComment'].trim() == '') {
    //   invalidSubmitMsg += 'Comment is mandatory\r <br/>';
    //   isSubmitValid = false;
    // }

    if (
      this.workItemFieldList.findIndex((x) => x.control_type == 'FILE') != -1 &&
      this.invoicebase64FileString == ''
    ) {
      invalidSubmitMsg += 'Please select file\r <br/>';
      isSubmitValid = false;
    }

    if (this.selectedDocumentType.isCommentMandatory && (this.frmInvoice.get(this.invoiceComment).value == '' ||
      this.frmInvoice.get(this.invoiceComment).value == undefined ||
      this.frmInvoice.get(this.invoiceComment).value == null)
    ) {
      invalidSubmitMsg += 'Comment is mandatory.\r <br/>';
      isSubmitValid = false;
    }

    if (config.is_Addprocess_In_Create_Work_page == true && (this.frmInvoice.get('nextQueueselected').value == 0 || this.frmInvoice.get('nextQueueselected').value == "" ||
      this.frmInvoice.get('nextQueueselected').value == undefined ||
      this.frmInvoice.get('nextQueueselected').value == null)) {
      invalidSubmitMsg += 'Next Queue is mandatory.\r <br/>';
      isSubmitValid = false;
    }

    if (!isSubmitValid) {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
      return;
    }

    let fieldsData = [];
    let lst = [];
    let lstRow = this.frmInvoice.getRawValue();
    let formValue = "";

    this.workItemFieldList.forEach(field => {

      formValue = lstRow[field.db_column_name];
      let displayText = '';

      if (formValue != undefined && formValue != null)
        formValue = formValue.toString();
      else
        formValue = '';

      // START: field length validation
      if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
        let fix_length = 0;
        if (field.min_length == field.max_length) {
          fix_length = field.min_length;
        }

        if (fix_length > 0 && (field.is_mandatory == 1 || formValue != '')) {

          if (formValue.toString().length != fix_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " must be " + fix_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " must be " + fix_length + ".";
          }
        }

        if (fix_length == 0 && field.min_length > 0 && (field.is_mandatory == 1 || formValue != '')) {
          if (formValue.toString().length < field.min_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " is min " + field.min_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is min " + field.min_length + ".";
          }
        }

        if (fix_length == 0 && field.max_length > 0) {
          if (formValue.toString().length > field.max_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of " + field.field_name + " is up to " + field.max_length + ".";
            else
              invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + field.field_name + " is up to " + field.max_length + ".";
          }
        }
      }
      // END: field length validation

      let value: string = ""

      if (field.control_type == "DATE") {
        value = this.commonService.dateFormating(formValue);
      }
      else {
        value = formValue;
      }

      if (field.control_type == "DROPDOWN") {
        displayText = field.options.find(d => d.id == value)?.name;
      }

      fieldsData.push({
        db_column_name: field.db_column_name,
        field_val: value.toString().trim(),
        controlType: field.control_type,
        displayText: displayText == undefined ? '' : displayText
      });

      lst.push({
        ParameterName: field.db_column_name,
        ParameterValue: value.toString().trim()
      });

    });

    if (invalidLengthMsg != '') {
      this.commonService.showMessageBox(invalidLengthMsg, 'Alert');
      return;
    }

    let toProcessId: number = 0;
    let is_request_Addprocess_In_Create_Work_page: string = "FALSE"
    if (config.is_Addprocess_In_Create_Work_page == true && (this.frmInvoice.get('nextQueueselected').value != 0)) {

      if (config.is_Addprocess_Id == this.frmInvoice.get('nextQueueselected').value) {
        toProcessId = this.frmInvoice.get('nextQueueselected').value;
        is_request_Addprocess_In_Create_Work_page = "TRUE"
      }

    }

    let df_params = {
      document_type_id: this.selectedDocumentType.docTypeId,
      document_detail_id: 0,
      lstParameter: lst,
      fromProcessId: 0,
      toProcessId: 0
    };


    //let Duplicate_ref_id: string = '';

    let jsonDuplicate: string = ''
    if (this.isDuplicate == false) {
      this.lstDuplicateData = [];
    }

    this.dataService.postData('getduplicate', df_params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res?.data?.Table?.length > 0 && this.isDuplicate == false) {
          this.lstDuplicateData = res.data.Table;
          this.duplicateDataKeys = Object.keys(this.lstDuplicateData[0]);
          this.showModal(this.duplicateInvoiceSubmittedModal, 'xl');
          //Duplicate_ref_id = res.data.Table[0].DUPLICATE_REF_ID

        }
        else {
          if (this.lstDuplicateData.length > 0) {
            this.potentialDuplicate = " as potential duplicate";
            jsonDuplicate = JSON.stringify(this.lstDuplicateData);

          }
          else {
            this.potentialDuplicate = "";
          }

          let params = {
            // // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
            // user_id: this.memorystore.getItem('userId'),
            // invoice_file: this.invoicebase64FileString,
            // fields_data: fieldsData,
            // document_type_id: this.selectedDocumentType.docTypeId,
            // comments: this.frmInvoice.value['invoiceComment'],
            // subgroup_id: this.commonService.selectedSubgroup,
            // priority: this.finalValue.toUpperCase(),
            // support_document_comments: this.frmInvoice.get(this.invoiceComment).value,
            // duplicate_ref_id: jsonDuplicate,
            // sub_doctype_id: this.selectedSubDocumentType.subdocTypeId,
            // project_id: Number(this.commonService.selectedProject),
            // process_id: toProcessId,
            // is_Addprocess_In_Create_Work_page: is_request_Addprocess_In_Create_Work_page,
            
            // // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
            // user_id: this.memorystore.getItem('userId'),
            encuserid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
            invoice_file: this.invoicebase64FileString,
            fields_data: fieldsData,
            document_type_id: this.selectedDocumentType.docTypeId,
            comments: this.frmInvoice.value['invoiceComment'],
            subgroup_id: this.commonService.selectedSubgroup,
            priority: this.finalValue.toUpperCase(),
            support_document_comments: this.frmInvoice.get(this.invoiceComment).value,
            duplicate_ref_id: jsonDuplicate,
            sub_doctype_id: this.selectedSubDocumentType.subdocTypeId,
            // project_id: Number(this.commonService.selectedProject),
            projectid:this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
            process_id: toProcessId,
            is_Addprocess_In_Create_Work_page: is_request_Addprocess_In_Create_Work_page,
          };

          this.dataService.postData('workitem', params).subscribe((res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
              if (res.data != null && res.data.length > 0 && res.data[0].urn != '') {
                this.submitAttachments(res.data[0]);
                this.createdInvoiceURN = res.data[0].urn;
                // this.commonService.setUserInfoToLocalStorage('documentDetailId', res.data[0].document_detail_id);
                this.memorystore.setItem('documentDetailId', res.data[0].document_detail_id);
                this.showModal(this.invoiceSubmittedModal, 'lg');
              } else {
                this.commonService.showMessageBox(res.error_message, 'Alert');
              }
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }
          },
          error => {
            if (error.includes("401")) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
          });
          this.isDuplicate = false;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });

  }

  postSubmitAction(action: string) {
    this.modalReference.close();
    if (action == 'process') {
      //this.router.navigate(['/transaction']);
      this.router.navigate(['/transaction'], {
        state: {},
      }).then(() => {
        //window.location.reload();
      });
    } else if (action == 'createNewItem') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['/create-work-item']);
    } else if (action == 'dashboard') {
      this.router.navigate(['/control-panel']);
    }
  }

  get f() {
    return this.frmInvoice.controls;
  }

  stepIndex: number = 0;
  steps: string[] = ['Normal', 'High'];//'Medium', arun decided to remove from the priority 
  //discussed and confirmed on 13-06-2022.
  finalValue: string = 'Normal';

  onSliderInputChange($event: any) {
    this.stepIndex = +$event.value;
    this.finalValue = this.steps[this.stepIndex];
  }

  callOnAutoCompleteChangedEvent(data) {
    this.frmInvoice.get(data.db_column_name).setValue(data.fieldValue);
    if (data.control_type == 'DROPDOWN') {
      this.changeDropdownFieldValue(data);
    } else if (data.control_type == 'TEXTBOX') {
      this.changeTextFieldValue(data);
    }
  }

  checkRestrictedKeywords(formControlName: string) {
    let foundedRestrictedKeyword = [];
    let input = this.frmInvoice.get(formControlName).value;
    this.restrictedKeywords.forEach((keyword) => {
      if (input.includes(keyword.restrict)) {
        input = input.replaceAll(keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.frmInvoice.get(formControlName).setValue(input);
      this.commonService.showMessageBox(
        'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
        'Warning'
      );
    }
  }
  // onSelectFile(imgFile: any) {

  //   this.frmInvoice.controls['uploadFileName'].setValue('');
  //   this.uploadFileName = '';

  //   if (this.commonService.validateFileUpload(imgFile.target.files[0], this.supportDocValidFileExtensions, this.supportDocFileSize)) {
  //     if (imgFile.target.files && imgFile.target.files[0]) {

  //       let fileName = imgFile.target.files[0].name.split('.').slice(0, -1).join('');
  //       let fileExt = imgFile.target.files[0].name.split('.').pop();

  //       this.frmInvoice.controls['uploadFileName'].setValue(
  //         fileName + '.' + fileExt
  //       );

  //       this.uploadFileName = fileName + '.' + fileExt;
  //       this.file=imgFile.target.files[0];
  //       let reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         this.fileBase64FileString = reader.result.toString();
  //         this.uploadAttachment(e);
  //       };

  //       reader.readAsDataURL(imgFile.target.files[0]);
  //       this.fileInput.nativeElement.value = '';
  //     } else {
  //       this.frmInvoice.controls['uploadFileName'].setValue('');
  //       this.uploadFileName = '';
  //     }
  //   } else {
  //     this.frmInvoice.controls['uploadFileName'].setValue('');
  //     this.uploadFileName = '';
  //   }
  // } 

  onSelectFile(imgFile: any) {
    debugger;
    const input = imgFile.target as HTMLInputElement;
    this.commonService.setLoading(false);
    this.commonService.showHideLoader(false);
    if (this.commonService.validateFileUpload(imgFile.target.files[0], this.supportDocValidFileExtensions, this.supportDocFileSize)) {
      if (imgFile.target.files && imgFile.target.files[0]) {
        /*Added by Dharshana for PII data check using Wisdomnext(Web side).*/
        // const target: DataTransfer = <DataTransfer>(imgFile.target);
        // if (target.files.length !== 1) {
        //   this.commonService.showMessageBox('Cannot Upload Multiple Files.', 'Alert');
        //   return;
        // }
        // const uploadFile = target.files[0];
        // const reader = new FileReader();
        // reader.onload = (e: any) => {
        //   const bstr: string = e.target.result;
        //   const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        //   // const arrayBuffer = e.target.result;
        //   // const data = new Uint8Array(arrayBuffer);
        //   // const workbook:XLSX.WorkBook = XLSX.read(data,{type:'array'});
        //   const sheetName: string = workbook.SheetNames[0];
        //   const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
        //   this.UploadedJsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        //   console.log(this.UploadedJsonData);
        //   this.piiDataCheck(e, imgFile, this.UploadedJsonData);
        // };
        // reader.readAsBinaryString(target.files[0]);
        /*Added by Dharshana for PII data check using Wisdomnext(Web side).*/
        /*modified by Dharshana for PII data check using Wisdomnext(api side).*/
        let fileName = imgFile.target.files[0].name.split('.').slice(0, -1).join('');
        let fileExt = imgFile.target.files[0].name.split('.').pop();

        this.frmInvoice.controls['uploadFileName'].setValue(
          fileName + '.' + fileExt
        );
        this.file = imgFile.target.files[0];
        this.uploadFileName = fileName + '.' + fileExt;

        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.fileBase64FileString = reader.result.toString();
          //Modified by Dharshana to impleemnt PII data check.
          this.uploadAttachment(e, imgFile);
          // this.piiDataCheck(e, imgFile);
          input.value = '';
          reader.onload = null;
          reader.onerror = null;
        };

        reader.readAsDataURL(imgFile.target.files[0]);        
        //this.fileInput.nativeElement.value = '';
        /*modified by Dharshana for PII data check using Wisdomnext(api side).*/
      } else {
        this.frmInvoice.controls['uploadFileName'].setValue('Choose File');
        this.uploadFileName = 'Choose File';
      }
    }
  }
  /* uploadAttachment() {
    if (
      this.uploadFileName == '' ||
      this.uploadFileName == undefined ||
      this.uploadFileName == 'Choose File' ||
      this.fileBase64FileString.length == 0
    ) {
      this.commonService.showMessageBox('Please choose attachment.', 'Alert');
      return;
    }
    let local_file_name = this.uploadFileName.split('.').slice(0, -1).join('.')
    let local_extension = '.' + this.uploadFileName.split('.').pop();
    let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 24 ? 0 : local_file_name.length - 24), (local_file_name.length < 24 ? local_file_name.length : 24));

    this.attachmentList.push({
      name: selected_file_name + local_extension,
      file: this.fileBase64FileString,
    });
    this.frmInvoice.controls['uploadFileName'].setValue('Choose File');
    this.uploadFileName = 'Choose File';
    this.fileBase64FileString = '';
    this.commonService.showMessageBox('Attachment uploaded.', 'Success');
  } */


  async uploadAttachment(event: any, imgFile: any) {
    debugger;
    const input = imgFile.target as HTMLInputElement;
    if (
      this.uploadFileName == '' ||
      this.uploadFileName == undefined ||
      this.uploadFileName == 'Choose File' ||
      this.fileBase64FileString.length == 0
    ) {
      this.commonService.showMessageBox('Please choose attachment.', 'Alert');
      return;
    }

    let local_file_name = this.uploadFileName.split('.').slice(0, -1).join('.')
    let local_extension = '.' + this.uploadFileName.split('.').pop();
    let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 50 ? 0 : local_file_name.length - 50), (local_file_name.length < 50 ? local_file_name.length : 50));
    this.attachmentFile = imgFile.target.files.item(0);
    this.attachmentName = selected_file_name + local_extension
    let FrmData: FormData = new FormData();
    FrmData.append('file', this.attachmentFile, this.attachmentName);
    FrmData.append('document_type_id', this.selectedDocumentType.docTypeId);
    // FrmData.append('project_id', this.commonService.selectedProject);
    FrmData.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    FrmData.append('attachment_name', selected_file_name + local_extension);
    FrmData.append('attachment_encoded', this.fileBase64FileString);
    FrmData.append('document_history_id', "0");
    FrmData.append('module_name', "AP");
    
    let attachmentBody = {
      document_type_id: Number(this.selectedDocumentType.docTypeId),
      project_id: Number(this.commonService.selectedProject),
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      attachment_name: selected_file_name + local_extension,
      attachment_encoded: this.fileBase64FileString,
      document_history_id: 0,
      module_name: 'AP'
    };
    await this.dataService.postFilePromise('createnew-Supportfile_upload_path', FrmData).then((res) => {
      if (res) {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res.success) {
            if (res.data != null) {
              this.attachmentList.push({
                name: selected_file_name + local_extension,
                file: this.fileBase64FileString,
                filePath: res.data.fPath,
                FileSize: this.commonService.getFileSize(this.file.size).toFixed(2) + ' ' + this.commonService.getFileSizeUnit(this.file.size),
                FileType: this.file.type,
                FileUrl: event.target.result,
                FileProgessSize: 0,
                FileProgress: 0
              });
              this.startProgress(this.file, res);
              //Added by imran on 13-01-2026 to fix same file upload
              input.value = '';
              FrmData = new FormData(); // Creates a fresh empty FormData

            }
            else {
              this.commonService.showMessageBox("Failed to upload", 'Warning');
            }
          }
          else {
            this.commonService.showMessageBox(res.errorMessage, 'Warning');
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
    this.frmInvoice.controls['uploadFileName'].setValue('Choose File');
    this.uploadFileName = 'Choose File';
    this.fileBase64FileString = '';
    return;
    // this.commonService.showMessageBox('Attachment uploaded.', 'Success');
  }

  //Added by Dharshana for PII data check using Wisdomnext(api side).
  // async piiDataCheck(event: any, imgFile: any) {
  //   if (
  //     this.uploadFileName == '' ||
  //     this.uploadFileName == undefined ||
  //     this.uploadFileName == 'Choose File' ||
  //     this.fileBase64FileString.length == 0
  //   ) {
  //     this.commonService.showMessageBox('Please choose attachment.', 'Alert');
  //     return;
  //   }

  //   let local_file_name = this.uploadFileName.split('.').slice(0, -1).join('.')
  //   let local_extension = '.' + this.uploadFileName.split('.').pop();
  //   let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 50 ? 0 : local_file_name.length - 50), (local_file_name.length < 50 ? local_file_name.length : 50));
  //   this.attachmentFile = imgFile.target.files.item(0);
  //   this.attachmentName = selected_file_name + local_extension
  //   let FrmData: FormData = new FormData();
  //   FrmData.append('file', this.attachmentFile, this.attachmentName);
  //   FrmData.append('document_type_id', this.selectedDocumentType.docTypeId);
  //   FrmData.append('project_id', this.commonService.selectedProject);
  //   FrmData.append('attachment_name', selected_file_name + local_extension);
  //   FrmData.append('attachment_encoded', this.fileBase64FileString);
  //   FrmData.append('document_history_id', "0");
  //   FrmData.append('module_name', "AP");

  //   let attachmentBody = {
  //     document_type_id: Number(this.selectedDocumentType.docTypeId),
  //     project_id: Number(this.commonService.selectedProject),
  //     user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
  //     attachment_name: selected_file_name + local_extension,
  //     attachment_encoded: this.fileBase64FileString,
  //     document_history_id: 0,
  //     module_name: 'AP'
  //   };
  //   await this.dataService.postFilePromise('check_Piidata_uploadFile', FrmData).then((res) => {
  //     //await this.dataService.piiDataCheckagent('fileextraction', FrmData).then((res) => {
  //     if (res) {
  //       if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
  //         if (res.success) {
  //           if (res.data != null) {
  //             var resultJson = JSON.parse(res.data);
  //             if (resultJson["prompt_response"] != undefined && resultJson["prompt_response"] != null) {
  //               var resultPrompt = resultJson["prompt_response"];
  //               if (resultPrompt.toString().includes("The provided data contains Personally Identifiable Information")||resultPrompt.toString().includes("The document contains Personally Identifiable Information")) {
  //                 this.commonService.showMessageBox(resultJson["prompt_response"], 'Alert');
  //               } else {
  //                 this.uploadAttachment(event, imgFile);
  //               }
  //             }
  //           }
  //           else {
  //             this.commonService.showMessageBox("Failed to upload", 'Warning');
  //           }
  //           //   if (resultJson["cost"]["prompt_tokens"] != undefined && resultJson["cost"]["prompt_tokens"] != null) {
  //           //     var resulttoken = resultJson["cost"]["prompt_tokens"];
  //           //     if (resulttoken == 2069 || resulttoken == 740) {
  //           //       this.commonService.showMessageBox(resultJson["prompt_response"], 'Alert');
  //           //     } else {
  //           //       this.uploadAttachment(event, imgFile);
  //           //     }
  //           //   }
  //           // }
  //           // else {
  //           //   this.commonService.showMessageBox("Failed to upload", 'Warning');
  //           // }
  //         }
  //         else {
  //           this.commonService.showMessageBox(res.errorMessage, 'Warning');
  //         }
  //       }
  //       else {
  //         if (res.errorCode != 0 && res.errorCode == 4000) {
  //           this.router.navigateByUrl('/unauthorized');
  //           return;
  //         }
  //         if (res.errorCode != 0 && res.errorCode == 3000) {
  //           this.commonService.showMessageBox("Internal error")
  //         }
  //       }
  //     }
  //   });
  //   this.frmInvoice.controls['uploadFileName'].setValue('Choose File');
  //   this.uploadFileName = 'Choose File';
  //   this.fileBase64FileString = '';
  //   // this.commonService.showMessageBox('Attachment uploaded.', 'Success');
  //   return;
  // }
  //Added by Dharshana for PII data check using Wisdomnext(python code).
  async piiDataCheck(event: any, imgFile: any) {
   this.commonService.setLoading(false);
    this.commonService.showHideLoader(false);
    if (
      this.uploadFileName == '' ||
      this.uploadFileName == undefined ||
      this.uploadFileName == 'Choose File' ||
      this.fileBase64FileString.length == 0
    ) {
      this.commonService.showMessageBox('Please choose attachment.', 'Alert');
      return;
    } else {
      this.PiiCheckModel = true;
      this.commonService.showMessageBox("PII Data Processing....", 'PII Agent');
    }

    let local_file_name = this.uploadFileName.split('.').slice(0, -1).join('.')
    let local_extension = '.' + this.uploadFileName.split('.').pop();
    let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 50 ? 0 : local_file_name.length - 50), (local_file_name.length < 50 ? local_file_name.length : 50));
    this.attachmentFile = imgFile.target.files.item(0);
    this.attachmentName = selected_file_name + local_extension
    let FrmData: FormData = new FormData();
    FrmData.append('file', this.attachmentFile, this.attachmentName);
    FrmData.append('document_type_id', this.selectedDocumentType.docTypeId);
    FrmData.append('project_id', this.commonService.selectedProject);
    FrmData.append('attachment_name', selected_file_name + local_extension);
    FrmData.append('attachment_encoded', this.fileBase64FileString);
    FrmData.append('document_history_id', "0");
    FrmData.append('module_name', "AP");

    let attachmentBody = {
      document_type_id: Number(this.selectedDocumentType.docTypeId),
      project_id: Number(this.commonService.selectedProject),
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      attachment_name: selected_file_name + local_extension,
      attachment_encoded: this.fileBase64FileString,
      document_history_id: 0,
      module_name: 'AP'
    };
    this.commonService.showHideLoader(false);
    await this.dataService.piiDataCheckagent('fileextraction', FrmData).then((res) => {
      this.commonService.showHideLoader(false);
      if (res) {
        if (res != null) {
          if (res.status == 200) {
            if (res.body != null) {
              var resultJson = res.body;
              if (resultJson["prompt_response"] != undefined && resultJson["prompt_response"] != null) {
                var resultPrompt = resultJson["prompt_response"];
                if (resultPrompt.toString().includes("The provided data contains Personally Identifiable Information") || resultPrompt.toString().includes("The document contains Personally Identifiable Information") || resultPrompt.toString().includes("The provided information contains Personally Identifiable Information")) {
                  this.commonService.closemessagebox();
                  // this.commonService.showMessageBox("PII Data Processing....", 'PII Agent');
                  this.commonService.editmessagebox("PII Data Processed", "PII Informatoin Identified in uploaded file please check.", resultJson["prompt_response"]);
                  this.PiiCheckModel = true;
                } else {
                  this.uploadAttachment(event, imgFile);
                }
              }
            }
            else {
              this.commonService.showMessageBox("Failed to upload", 'Warning');
            }
            //   if (resultJson["cost"]["prompt_tokens"] != undefined && resultJson["cost"]["prompt_tokens"] != null) {
            //     var resulttoken = resultJson["cost"]["prompt_tokens"];
            //     if (resulttoken == 2069 || resulttoken == 740) {
            //       this.commonService.showMessageBox(resultJson["prompt_response"], 'Alert');
            //     } else {
            //       this.uploadAttachment(event, imgFile);
            //     }
            //   }
            // }
            // else {
            //   this.commonService.showMessageBox("Failed to upload", 'Warning');
            // }
          }
          else {
            this.commonService.showMessageBox(res.errorMessage, 'Warning');
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
    this.frmInvoice.controls['uploadFileName'].setValue('Choose File');
    this.uploadFileName = 'Choose File';
    this.fileBase64FileString = '';
    // this.commonService.showMessageBox('Attachment uploaded.', 'Success');
    return;
  }
  //Added by Dharshana for PII data check using Wisdomnext(Web side).
  // async piiDataCheck(event: any, imgFile: any, filedata) {
  //   // if (
  //   //   this.uploadFileName == '' ||
  //   //   this.uploadFileName == undefined ||
  //   //   this.uploadFileName == 'Choose File' ||
  //   //   this.fileBase64FileString.length == 0
  //   // ) {
  //   //   this.commonService.showMessageBox('Please choose attachment.', 'Alert');
  //   //   return;
  //   // }    
  //   const jsonbody = {
  //     "context": filedata,
  //     "fetch_from_db": false,
  //     "human_message": "Check PII Data",
  //     "include_chat_history": false,
  //     "model_name": "gpt-4",
  //     "module_type": "BusinessModule",
  //     "no_of_past_messages": 0,
  //     "provider_name": "AzureOpenAI",
  //     "should_anonymize": false,
  //     "should_clear_session": false,
  //     "should_scan_pii": true,
  //     "system_message": "",
  //     "temperature": 0.1
  //   }
  //   await this.dataService.piiDataCheck('non-rag-without-guardrail', jsonbody).then((res) => {
  //     if (res) {
  //       if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
  //         if (res.success) {
  //           if (res.data != null) {
  //             var resultJson = JSON.parse(res.data);
  //             if (resultJson["prompt_response"] != undefined && resultJson["prompt_response"] != null) {
  //               var resultPrombp = resultJson["prompt_response"];
  //               if (resultPrombp.toString().includes("The provided data contains Personally Identifiable Information")) {
  //                 this.commonService.showMessageBox(resultJson["prompt_response"], 'Alert');
  //               } else {
  //                 this.uploadAttachment(event, imgFile);
  //               }
  //             }
  //           }
  //           else {
  //             this.commonService.showMessageBox("Failed to upload", 'Warning');
  //           }
  //         }
  //         else {
  //           this.commonService.showMessageBox(res.errorMessage, 'Warning');
  //         }
  //       }
  //       else {
  //         if (res.errorCode != 0 && res.errorCode == 4000) {
  //           this.router.navigateByUrl('/unauthorized');
  //           return;
  //         }
  //         if (res.errorCode != 0 && res.errorCode == 3000) {
  //           this.commonService.showMessageBox("Internal error")
  //         }
  //       }
  //     }
  //   });
  //   this.frmInvoice.controls['uploadFileName'].setValue('Choose File');
  //   this.uploadFileName = 'Choose File';
  //   this.fileBase64FileString = '';
  //   // this.commonService.showMessageBox('Attachment uploaded.', 'Success');
  //   return;
  // }


  uploadInvAttachment(event: any) {
    let attachmentBody = {
      document_type_id: Number(this.selectedDocumentType.docTypeId),
      project_id: Number(this.commonService.selectedProject),
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      attachment_name: this.frmInvoice.get(this.invcontrolName).value,
      attachment_encoded: this.invoicebase64FileString,
      document_history_id: 0,
      module_name: 'AP'
    };
    this.dataService.postDataPromise('createnew-invfile_upload_path', attachmentBody).then((res) => {
      if (res) {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res.success) {
            if (res.data != null) {
              this.invoiceattachmentList = [];
              this.invoiceattachmentList.push({
                name: res.data.attachmentName,
                file: this.fileBase64FileString,
                filePath: res.data.fPath,
                fileType: "invoice"
              });
              this.startProgress(this.file, res);
            }
            else {
              this.commonService.showMessageBox("Failed to upload", 'Warning');
            }
          }
          else {
            this.commonService.showMessageBox(res.errorMessage, 'Warning');
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
    // this.frmInvoice.controls[this.invcontrolName].setValue('Choose File');
    // this.uploadFileName = 'Choose File';
    // this.fileBase64FileString = '';

  }

  deleteAttachment(index: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: 'Are you sure want to delete this attachment?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // this.dataService.deleteData('transaction-attachments/' + id, null, null).subscribe(res => {
        //   this.fileAttachmentHistoryList = this.fileAttachmentHistoryList.filter(el => el.id !== id);
        // });
        this.attachmentList.splice(index, 1);
        this.commonService.showMessageBox('Attachment deleted.', 'Success');
      }
    });
  }

  submitAttachments(response_data: any) {

    let requestBody = [];
    this.attachmentList.forEach((item) => {
      let attachmentBody = {
        document_detail_id: Number(response_data.document_detail_id),
        document_type_id: Number(this.selectedDocumentType.docTypeId),
        // project_id: Number(this.commonService.selectedProject),
        projectid: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
        process_id: Number(response_data.document_process_id),
        // // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
        // user_id: Number(this.memorystore.getItem('userId')),
        encuserid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
        attachment_name: item.name,
        attachment_encoded: item.file,
        document_history_id: response_data.document_history_id,
        module_name: 'AP',
        attachmentFrom: "createinvoice",
        filePath: item.filePath,
        is_supporting_file: 1,
      };
      requestBody.push(attachmentBody);
    });

    this.invoiceattachmentList.forEach((item) => {
      let attachmentBody = {
        document_detail_id: Number(response_data.document_detail_id),
        document_type_id: Number(this.selectedDocumentType.docTypeId),
        // project_id: Number(this.commonService.selectedProject),
        projectid: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
        process_id: Number(response_data.document_process_id),
        // // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
        // user_id: Number(this.memorystore.getItem('userId')),
        encuserid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
        attachment_name: response_data.uploaded_file_name,// item.name,
        attachment_encoded: item.file,
        document_history_id: response_data.document_history_id,
        module_name: 'AP',
        attachmentFrom: "createinvoice",
        filePath: item.filePath,
        is_supporting_file: 0,
        xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
      };
      requestBody.push(attachmentBody);
    });

    this.dataService.postData('transaction-attachmentsList', requestBody).subscribe((res) => {
      if (res) {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          } if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false,
    });
  }

  ngAfterViewInit() {
    this.renderer.removeAttribute(this.modalReference.nativeElement, 'role');
  }

  onTextBoxKeyPressEvent(event: any, field: any) {
    const reg = this.commonService.getRegForDecimal;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  checkIsOCRDocumentType() {

    let documentTypeList = this.documentType_MST;
    let selecteddocumentTypeId = Number(this.selectedDocumentType.docTypeId);
    let selectedDocType = documentTypeList.filter(doc => doc.document_type_id == selecteddocumentTypeId);
    if (selectedDocType != null) {
      let document_type_name = selectedDocType[0].document_type_name;
      if (document_type_name.includes('TML')) {
        this.company_type = 'TML';
      }
      if (document_type_name.includes('TMPVL')) {
        this.company_type = 'TMPVL';
      }
      if (selectedDocType[0].ocr_document_type_id > 0) {
        this.is_OCR_Enabled = true;
        return true;
      }
    }
    return false;
  }

  call_OCR_API(request) {
    let ocr_API_Status = false;
    let params = {
      // project_id: this.commonService.getUserInfoFromLocalStorage('projectId'),
      project_id: this.memorystore.getItem('projectId'),
      Document_Detail_Id: request.data.document_detail_id.toString(),
      URN: request.data.urn,
      DocType: this.selectedDocumentType.docTypeId.toString(),//"2"
      DocPath: request.data.uploadedInvFilePath, //"E:\\DIAS\\TataMotors\\TML_Docs\\INV_2027309522.pdf",
      Source: "AP Workflow",
    };
    let dialog_Message = " <br /> <b> Please wait, OCR extraction is In-Progress.</b>";

    let ocrDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: "Message",
        message: dialog_Message,
        messageBoxType: 'progress-bar',
      }
    });

    this.dataService.postData("ocr", params).subscribe(res => {
      if (res != null) {
        ocr_API_Status = false;
        if (res.status == true) {
          ocr_API_Status = true;
          dialog_Message = "OCR extraction successfully completed for this URN - " + request.data.urn;
        }
        else {
          ocr_API_Status = true;
          dialog_Message = "OCR extraction failed for this URN - " + request.data.urn;
        }

        ocrDialogRef.componentInstance.message = dialog_Message;
        ocrDialogRef.componentInstance.MessageBoxType = "ok";
        ocrDialogRef.componentInstance.confirmButtonText = "Proceed";

        ocrDialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed && ocr_API_Status) {
            // this.commonService.setUserInfoToLocalStorage('documentDetailId', request.data.document_detail_id);
            this.memorystore.setItem('documentDetailId', request.data.document_detail_id);
            // this.router.navigate(['/transaction']);
            this.router.navigate(['transaction'], {
              state: {},
            }).then(() => {
              window.location.reload();
            });


          }
        });
      }
    });
  }

  // duplicateGridCellClickEvent(cellData) {
  //   if (cellData.columnName.toLowerCase() == "attachment") {
  //     this.commonService.openAttachment(cellData.rowData.URN, '');
  //   }
  // }
  getCellStyle(col: string): Object {

    let hyperlinkCols: any = ['attachment'];
    if (hyperlinkCols.includes(col.toLowerCase())) {
      return { 'cursor': 'pointer', 'text-decoration': 'underline', 'color': '#76449b', 'font-weight': 600 };
    } {
      return {};
    }
  }
  duplicateGridCellClickEventNew(columnName: String, rowData: any, rowIndex: number) {
    if (columnName.toLowerCase() == "attachment") {
      this.commonService.openAttachment(rowData.URN, '');
    }


  }

  getInvoiceDocuments() {
    this.invoiceDocFileSize = {};
    this.invoiceDocValidFileExtensions = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('document_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('document_type_id', this.encryptDecryptservice.encryptUsingAES256(this.selectedDocumentType.docTypeId));
    params = params.append('document_type', 'INVOICE_DOC');
    this.dataService
      .getData('upload-file-validation', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.invoiceDocFileSize = res.data[0]?.file_size;
              this.invoiceDocValidFileExtensions = res.data[0]?.file_type.split(',');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }

  getSupportingDocuments() {
    this.supportDocFileSize = {};
    this.supportDocValidFileExtensions = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('document_type_id', this.selectedDocumentType.docTypeId);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('document_type_id', this.encryptDecryptservice.encryptUsingAES256(this.selectedDocumentType.docTypeId));
    params = params.append('document_type', 'SUPPORTING_DOC');
    this.dataService
      .getData('upload-file-validation', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.supportDocFileSize = res.data[0]?.file_size;
              this.supportDocValidFileExtensions = res.data[0]?.file_type.split(',');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }

  omit_special_char(e, regExp) {
    // var k;
    // k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));

    //var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    if (regExp == "" || regExp == null || regExp == undefined)
      return true;

    var regex = new RegExp(regExp);
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }
  //added by sana for limit the input field length- start
  limitLength(event: Event, maxLength: number) {
    var input = event.target as HTMLInputElement;
    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
    }
  }
  //added by sana for limit the input field length- end

  omit_onPaste(e) {
    ///(paste)="onPaste($event)" add this line into html input.
    e.preventDefault();
    return false;
  }
  getDateFieldValue(field: any) {
    return this.frmInvoice.get(field.db_column_name).value;
  }
  clearDateFieldValue(field: any) {
    this.frmInvoice.get(field.db_column_name).setValue('');
    //field.field_value='';
  }

  async startProgress(index, res) {

    this.isLoadProgress = true;
    let filteredFile = this.attachmentList.filter((u, index) => index === index)
      .pop();
    //  logic to fetch the percentage progress
    if (filteredFile != null) {
      let fileSize = this.commonService.getFileSize(this.file.size);
      let fileSizeInWords = this.commonService.getFileSizeUnit(this.file.size);
      if (this.commonService.isApiSetup) {
        if (res.status === 'progress') {
          let completedPercentage = parseFloat(res.message);
          filteredFile.FileProgessSize = `${(
            (fileSize * completedPercentage) /
            100
          ).toFixed(2)} ${fileSizeInWords}`;
          filteredFile.FileProgress = completedPercentage;
        } else if (res.status === 'completed') {
          filteredFile.Id = res.Id;
          filteredFile.FileProgessSize = fileSize + ' ' + fileSizeInWords;
          filteredFile.FileProgress = 100;
          this.isLoadProgress = false;
          this.commonService.showMessageBox('Attachment uploaded.', 'Success');
        }
      } else {
        for (
          var f = 0;
          f < fileSize + fileSize * 0.0001;
          f += fileSize * 0.01
        ) {
          filteredFile.FileProgessSize = f.toFixed(2) + ' ' + fileSizeInWords;
          var percentUploaded = Math.round((f / fileSize) * 100);
          filteredFile.FileProgress = percentUploaded;
          if (parseFloat(filteredFile.FileProgessSize.match(/[\d\.]+/)) !== fileSize) {
            await this.progressLoader(Math.floor(percentUploaded));
          }
          else {
            this.isLoadProgress = false;
            this.commonService.showMessageBox('Attachment uploaded.', 'Success');
          }
        }
      }
    }
  }
  progressLoader(ms: number) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }
  //  public editmessagebox(text: string){
  //    const dialogRef1 = this.dialog.afterOpened.subscribe(()=>{
  //     this.dailogbox.showpiiresponse(text);
  //    })
  // }
}

